module.exports = __webpack_public_path__ + "static/media/Ie.653a2706.jpg";